import React, {
  cloneElement,
  useState,
} from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import StatusChanger from '../StatusChanger'
import DashedLinkAbort from '../DashedLinkAbort'
import DefaultLink from '../DefaultLink'
import IconTrashCan from '../icons/IconTrashCan'
import IconEdit from '../icons/IconEdit'
import ButtonComplete from '../ui/ButtonComplete'

const TableBody = (props) => {
  const { data, options, actions, padding, selectedRow, lastRun, ordersList } = props

  const cellGenerator = (column, row) => {
    switch (column.type) {
      case 'component':
        return cloneElement(column.component, {
          row,
          actions: actions ? actions[column.dataKey] : {},
        })
      case 'date':
        return moment(row[column.dataKey].split(' ')[0]).format('MM/DD/YYYY')
      case 'select':
        return (
          <StatusChanger
            currentStatus={row[column.dataKey]}
            options={column.options}
            isReadOnly={column.isReadOnly}
            disabled={column.disabled}
            onSelectStatus={
              column.isReadOnly ? null : props.onSelectStatus.bind(this, row)
            }
            key={column.key}
            dataKey={column.dataKey}
            minWidth={column.minWidth}
            colorless={column.colorless}
          />
        )
      case 'id':
        return '...' + row.UUID.slice(-4)
      case 'dashed-link':
        return (
          <DashedLinkAbort
            name={'Abort'}
            onClick={(e) => {
              e.stopPropagation()
            }}
            onSelectStatus={
              column.isReadOnly ? null : props.onSelectStatus.bind(this, row)
            }
            row={row}
            options={column.options}
            className={'order__info'}
          />
        )
      case 'button':
        return (
          <ButtonComplete
            style={
              column.cellPadding ? { paddingLeft: column.cellPadding } : {}
            }
            onClick={(e) => {
              e.stopPropagation()
            }}
            onSelectStatus={
              column.isReadOnly ? null : props.onSelectStatus.bind(this, row)
            }
            className={'order__info'}
            name={'Complete'}
            row={row}
            options={column.options}

          />
        )
      case 'default-link':
        if (column.isConditional) {
          return row[column.dataKey] ? <DefaultLink /> : null
        } else {
          return <DefaultLink />
        }
      case 'delete':
        return (
          <IconTrashCan
            onClick={(e) => {
              e.stopPropagation()
              actions.delete(row)
            }}
          />
        )
      case 'edit':
        return <IconEdit onClick={() => actions[column.dataKey](row)} />
      case 'text-prefix':
        return column.prefix + row[column.dataKey]
      case 'text-postfix':
        const amount = row[column.dataKey]
        return (
          amount +
          ' ' +
          (amount === 0 || amount > 1 ? column.postfix + 's' : column.postfix)
        )
      case 'blank':
        return <span className="table__empty-cell" />
      case '--':
        return (
          <span className="table__empty-cell table__empty-cell--dash-dash">
            --
          </span>
        )
      case 'order-run':
        if (row.type === 'final_run') {
          return (
            <span
              style={
                column.cellPadding ? { paddingLeft: column.cellPadding } : {}
              }>
              Final Run
            </span>
          )
        } else {
          return <span
            style={
              column.cellPadding ? { paddingLeft: column.cellPadding } : {}
            }>
            {row[column.dataKey]}
          </span>
        }


      case 'text':
      case 'notes':
      default:
        return (
          <span className='capitalize'
                style={
                  column.cellPadding ? { paddingLeft: column.cellPadding } : {}
                }
                dangerouslySetInnerHTML={{ __html: row[column.dataKey] }}
          >

          </span>
        )
    }
  }
  const rowOnClick = (row) => {
    if (props.rowOnClick) {
      props.rowOnClick(props.keyProp ? row[props.keyProp] : row.UUID, row)
    }
  }

  const rowClassName = (id) => {

    return `table__row ${props.isClickable ? 'table__row--clickable' : ''} ${
      selectedRow === id ? 'table__row--selected' : ''
    }`
  }


  const specificPadding = () => {
    return padding ? { padding } : {}
  }
  return (
    <div className="table__body">
      <ul className="table__body-list">
        {data &&
         data.map((row, index) => {
           return (
             <li
               className={rowClassName(
                 props.keyProp ? row[props.keyProp] : row.UUID,
               )}
               key={props.keyProp ? row[props.keyProp] : row.UUID}
               onClick={() => rowOnClick(row)}
             >
               {' '}
               <ul className={row.type === 'final_run' ? 'table__row-list__blue' : 'table__row-list'} style={specificPadding()}>
                 {options.columns.map((col) => {
                   let column = col
                   if (ordersList) {
                     if (index !== data.length - 1 && column.name === '' || index !== data.length - 1 && column.name === '-') {
                       column.type = null
                     }
                     if (index === data.length - 1 && column.name === '') {
                       column.type = 'button'
                     }
                     if (index === data.length - 1 && column.name === '' && row.status === 'completed' || row.status === 'aborted') {
                       column.type = null
                     }
                     if (index === data.length - 1 && column.name === '-') {
                       column.type = 'dashed-link'
                     }
                     if (index === data.length - 1 && column.name === '-' && row.status === 'completed' || row.status === 'aborted') {
                       column.type = null
                     }
                   }
                   return (
                     <li
                       className={
                         column.flexGrow
                           ? `${
                             column.flexGrow
                           } table__row-item table__row-item--${column.type}`
                           : `table__row-item table__row-item--${column.type}`
                       }
                       title={column.type === 'notes' ? row.notes : ''}
                       key={'' + row.UUID + column.name + column.type}
                     >
                       {cellGenerator(column, row)}
                     </li>
                   )
                 })}
               </ul>
             </li>
           )
         })}
      </ul>
    </div>
  )
}

export default withRouter(TableBody)
